module.exports = __webpack_public_path__ + "static/media/Henry Clay - 1832.50d35c70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Henry Clay - 1832.jpg
// module id = 486
// module chunks = 0